import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import styles from '../AdminFullPage.module.scss'

function ExternalLinkTab({ title, description, to, label }) {
  const { t } = useTranslation('common')
  return (
    <div>
      <h2 className={styles.section_title}>{title}</h2>
      {description ? (
        <p style={{ color: 'var(--color-text-muted)', marginBottom: 16 }}>
          {description}
        </p>
      ) : null}
      <Link to={to} className="unv-btn">
        {label || t('admin.fullPage.external_open_section')}
      </Link>
    </div>
  )
}

export default ExternalLinkTab
